import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Trees, Menu, X } from 'lucide-react';

const Navbar = ({ scrolled }) => {
  const [open, setOpen] = useState(false);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 backdrop-blur-md ${
        scrolled ? 'bg-white/90 shadow-sm' : 'bg-white/70'
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <Trees size={32} color="#1A3C34" />
          <span
            className="text-xl md:text-2xl font-bold"
            style={{ fontFamily: 'Playfair Display, serif', color: '#1A3C34' }}
          >
            The Bagh Home
          </span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          <Link to="/about" className="font-medium hover:opacity-70" style={{ color: '#1A3C34' }}>
            About Us
          </Link>
          <Link to="/forest" className="font-medium hover:opacity-70" style={{ color: '#1A3C34' }}>
            Forest
          </Link>
          <Link to="/safari" className="font-medium hover:opacity-70" style={{ color: '#1A3C34' }}>
            Safari
          </Link>
           <Link to="/rooms" className="font-medium hover:opacity-70" style={{ color: '#1A3C34' }}>
            Rooms
          </Link>
          
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-[#1A3C34]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-md px-6 pb-6 space-y-4">
          <Link to="/about" onClick={() => setOpen(false)} className="block text-lg font-medium text-[#1A3C34]">
            About Us
          </Link>
          <Link to="/forest" onClick={() => setOpen(false)} className="block text-lg font-medium text-[#1A3C34]">
            Forest
          </Link>
          <Link to="/safari" onClick={() => setOpen(false)} className="block text-lg font-medium text-[#1A3C34]">
            Safari
          </Link>
         <Link to="/rooms" onClick={() => setOpen(false)} className="block text-lg font-medium text-[#1A3C34]">
            Rooms
          </Link>   
        </div>
      )}
    </nav>
  );
};

export default Navbar;
